/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomDialog from 'components/modals/common/CustomDialog';
import CustomGrid from '../../../components/grids/CustomGrid';
import { findMpEquipment, findMpEquipmentHistory } from '../../../apis/mp/MpEquipment';
import { MpEquipment, MpEquipmentHistory } from '../../../models/mp/MpEquipment';
import { useMessageBar } from '../../../hooks/useMessageBar';
import { tb } from '../../../components/layouts/Table';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { MpItem } from '../../../models/mp/MpItem';
import { SubTitleGroup, SubTitleLayout } from '../../../components/layouts/ContentLayout';

interface Props {
  open: boolean;
  close: (isDone?: boolean) => void;
  title: string;
  condition?: {
    mpItemId?: string;
    horExplYn?: string;
  };
}

/**
 * mp 대상 설비 이력 조회 팝업
 * @param open
 * @param close
 * @param condition
 * @constructor
 */
export const MpEquipmentPopUp = ({ open, close, title, condition }: Props) => {
  const { t } = useTranslation();
  const { openMessageBar } = useMessageBar();

  const [mpItemStatHis, setMpItemStatHis] = useState<MpItem[]>([]);
  const [rowData, setRowData] = useState<MpEquipment[]>([]);
  console.log('rowdata', rowData);

  // search
  useEffect(() => {
    findMpEquipment(condition).then((result) => {
      if (result !== null) {
        setRowData(result);
      } else {
        openMessageBar({
          type: 'error',
          content: t(
            'com.msg.요청 정보 조회 중 오류가 발생했습니다.',
            '요청 정보 조회 중 오류가 발생했습니다.'
          ),
        });
        return false;
      }
    });
  }, [condition?.mpItemId]);

  const onInitialized = (grid) => {
    console.log('onInitialized... ');
  };

  //FactoryId, Factory명, 설비ID, 설비명, 설비레벨, 사용여부, 변경사유, 수정자, 최종수정일
  //법인, 공정, 설비군, FACTORY ID, FACTORY 명, 공장(동), 설비ID, 설비명, 설비레벨, 개조담당자명
  const layoutDefinition = [
    {
      header: String(t('com.label.FactoryId', 'FactoryId')),
      binding: 'prdnPlntCd',
      width: 120,
    },
    {
      header: String(t('com.label.Factory명', 'Factory명')),
      binding: 'prdnPlntNm',
      align: 'left',
      width: 120,
    },
    {
      header: String(t('com.label.설비ID', '설비ID')),
      binding: 'equipmentId',
      width: 120,
    },
    {
      header: String(t('com.label.설비명', '설비명')),
      binding: 'equipmentName',
      align: 'left',
      width: '*',
    },
    {
      header: String(t('com.label.설비레벨', '설비레벨')),
      binding: 'equipmentLevel',
      width: 80,
    },
    // {
    //   header: String(t('com.label.사용여부', '사용여부')),
    //   binding: 'useYn',
    //   width: 80,
    // },
    // {
    //   header: String(t('com.label.변경사유', '변경사유')),
    //   binding: 'chgRsnCtn',
    //   align: 'left',
    //   width: '*',
    // },
    {
      header: String(t('com.label.개조담당자', '개조담당자')),
      binding: 'cortCrgeUserNm',
      width: 100,
    },
    // {
    //   header: String(t('com.label.최종수정일', '최종수정일')),
    //   binding: 'dataUpdDtm',
    //   width: 100,
    // },
  ];

  return (
    <>
      <CustomDialog title={title} open={open} onClose={close}>
        <TableContainer css={tb.table}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>{t('mp.label.ItemNo', 'ItemNo')}</TableCell>
                <TableCell>{rowData.length > 0 && condition?.mpItemId}</TableCell>
                <TableCell>{t('mp.label.법인', '법인')}</TableCell>
                <TableCell>{rowData.length > 0 && rowData[0].copCd}</TableCell>
                <TableCell>{t('mp.label.공정', '공정')}</TableCell>
                <TableCell>{rowData.length > 0 && rowData[0].processName}</TableCell>
                <TableCell>{t('mp.label.설비군', '설비군')}</TableCell>
                <TableCell>{rowData.length > 0 && rowData[0].equipmentGroup}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <SubTitleLayout>
          <SubTitleGroup>&nbsp;</SubTitleGroup>
        </SubTitleLayout>
        <CustomGrid
          layoutDefinition={layoutDefinition}
          rowData={rowData}
          height={300}
          align={'center'}
          allowPinning={false}
          isFilter={false}
          isReadOnly={true}
          isSelector={false}
          initialized={onInitialized}
        />
      </CustomDialog>
    </>
  );
};
